import actionTypes from '../actionTypes';

export function requestJoinToSport(payload?: any) {
  return {
    type: actionTypes.JOIN_TO_SPORT_REQUEST,
    payload
  };
}

export function failJoinToSport(e: any) {
  return {
    type: actionTypes.JOIN_TO_SPORT_FAILURE,
    exception: e,
  };
}
